import orderBy from 'lodash/orderBy';
import * as React from 'react';
import { SeatStyle, SeatStyleCulture } from '../../classes/seat';
import LegendContent from './legend-content';

interface ILegendProps {
    seatStyles: Array<SeatStyle>;
    seatStyleCultures: Array<SeatStyleCulture>;
    legendTitle: string;
    legendModalText: string;
    legendTitleAltText: string;
    selectedSeats: boolean;
    legendFlyOut: boolean;
    updateLegendFlyout: (updateFlyout: boolean) => void;
    isMobile: boolean;
}

interface ILegendState {
    firstTimeHidden: boolean; //used to keep track so we only close the legend once so if users want to use the legend on mobile, they can open it again
}

class Legend extends React.PureComponent<ILegendProps, ILegendState>{

    constructor(props) {
        super(props);
        this.state = { firstTimeHidden: false };
    }
    componentWillReceiveProps(nextProps: ILegendProps) {

        if (!this.state.firstTimeHidden && nextProps.isMobile && nextProps.selectedSeats) {
            if (this.props.legendFlyOut) {
                nextProps.updateLegendFlyout(false);
            }

            this.setState({ firstTimeHidden: true });
        }
    }

    render() {
        const arrowIcon = '<use xlink:href="#icon-arrow-down" />';
        const useTag = '<use xlink:href="#icon-close" />';

        const culturesWithDisplayName = this.props.seatStyleCultures.filter(culture => culture.displayName != null);

        const visibleStyles = orderBy(this.props.seatStyles.filter(style => { return culturesWithDisplayName.some(culture => culture.seatStyleId === style.id) }),
            (style) => {
                return culturesWithDisplayName.filter(cultur => cultur.seatStyleId == style.id)[0].legendOrder;
            });

        return (
            <div className={"legend-container" + (this.props.legendFlyOut ? " open" : "")}>
                <button onClick={(evt) => { this.props.updateLegendFlyout(false) }} type="button" className="legend-close-icon">
                    {/*todo make this more dynamic */}
                    <span className="visually-hidden">Close Legend</span>
                    <svg dangerouslySetInnerHTML={{ __html: useTag }} />
                </button>

                <LegendContent {...this.props} renderModal={false} />

                {
                    !this.props.legendFlyOut ?
                        <div className="legend-arrow-icon" onClick={(evt) => { this.props.updateLegendFlyout(true) }}>
                            <svg className={"legend-arrow-icon-svg"} dangerouslySetInnerHTML={{ __html: arrowIcon }} />
                        </div>
                        : null
                }
            </div>
        );
    }
}

export default Legend;